import Vue from "vue";
import { getRemoteConfig, fetchAndActivate, getValue, isSupported } from "firebase/remote-config";
import { firebaseApp } from "@/firebase";

/**
 * Aviso general del estado del servicio, el mismo en la plataforma y en el campus (riskmann2-capacitaciones-by-sofu,
 * src/services/avisoServicio.js). SOFU lo enciende desde Firebase → Remote Config, parámetro `aviso_servicio`, sin
 * desplegar:
 *
 *   {"activo": true, "titulo": "Novedad en el servicio", "mensaje": "Nuestro proveedor de servidores…"}
 *
 * Con "activo": false, sin mensaje o sin el parámetro, no se muestra. Es para lo que SOFU ya confirmó (una falla del
 * proveedor vista en Service Health, un mantenimiento programado): el navegador no distingue una caída del proveedor,
 * una falla nuestra o el internet de la persona. Remote Config no depende de las Cloud Functions, así que el aviso
 * llega aunque ellas no respondan (como el 2026-10-22, de 4:39 a 5:36 p. m.).
 */
export const PARAMETRO_AVISO = "aviso_servicio";

// Cada cuánto se vuelve a preguntar mientras la pestaña sigue abierta (y al volver a ella)
const CADA_MS = 5 * 60 * 1000;

export const avisoServicio = Vue.observable({ activo: false, titulo: "", mensaje: "" });

/** El aviso a partir del valor del parámetro; cualquier cosa rara se toma como apagado. */
export function leerAviso(valor) {
    try {
        const datos = JSON.parse(valor || "{}") || {};
        const texto = (campo) => (typeof datos[campo] === "string" ? datos[campo].trim() : "");
        const mensaje = texto("mensaje");
        return { activo: datos.activo === true && mensaje !== "", titulo: texto("titulo"), mensaje };
    } catch (error) {
        return { activo: false, titulo: "", mensaje: "" };
    }
}

let iniciado = false;

/** Lee el aviso y lo mantiene al día. Se llama una vez, al montar la app. */
export async function iniciarAvisoServicio() {
    if (iniciado) return;
    iniciado = true;
    // Con los emuladores la app usa un proyecto de demostración, que no tiene Remote Config
    if (process.env.VUE_APP_USE_EMULATORS === "true") return;
    try {
        if (!(await isSupported())) return;
    } catch (error) {
        return;
    }

    const remoteConfig = getRemoteConfig(firebaseApp);
    remoteConfig.settings.minimumFetchIntervalMillis = CADA_MS;
    remoteConfig.defaultConfig = { [PARAMETRO_AVISO]: '{"activo": false}' };

    const actualizar = async () => {
        try {
            await fetchAndActivate(remoteConfig);
        } catch (error) {
            // Sin respuesta de Remote Config se queda con lo último que se tenía
        }
        Object.assign(avisoServicio, leerAviso(getValue(remoteConfig, PARAMETRO_AVISO).asString()));
    };

    await actualizar();
    setInterval(actualizar, CADA_MS);
    document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") actualizar();
    });
}
